import type { BrandGroupFraming } from "./BrandGroupedProducts";

// LiveToolbar: how brand groups are separated in the Brands view. Shared by
// the saved products and collection pages so the choice carries across both.
export const BRAND_FRAMING_DIVIDERS = 1;
export const BRAND_FRAMING_CARDS = 2;

const BRAND_FRAMINGS: Record<number, BrandGroupFraming> = {
  [BRAND_FRAMING_DIVIDERS]: "dividers",
  [BRAND_FRAMING_CARDS]: "cards",
};

export const brandFramingForVariant = (variant: number): BrandGroupFraming =>
  BRAND_FRAMINGS[variant] ?? "dividers";

export const brandFramingVariantGroup = (
  active: number,
  onChange: (variant: number) => void
) => ({
  title: "Brand groups",
  queryKey: "brand-framing",
  variants: [
    { variantNumber: BRAND_FRAMING_DIVIDERS, label: "Dividers" },
    { variantNumber: BRAND_FRAMING_CARDS, label: "Bordered cards" },
  ],
  active,
  onChange,
});
